
const SolutionsSection = () => {
  const solutions = [
    {
      number: '01',
      title: 'Conseil Stratégique sur Mesure',
      description: 'Bénéficiez de l\'expertise de consultants seniors pour affiner votre stratégie d\'entreprise. Développement, diversification, transformation digitale, internationalisation : des recommandations concrètes et actionnables pour accélérer votre croissance et sécuriser votre avenir.',
      benefits: [
        'Audit stratégique complet',
        'Plan de développement personnalisé',
        'Accompagnement transformation',
        'Suivi des performances',
      ],
      image: 'https://public.readdy.ai/ai/img_res/a1ce031ece0187ba9000740607171012.jpg',
    },
    {
      number: '02',
      title: 'Cercle de Dirigeants',
      description: 'Rejoignez un réseau exclusif de chefs d\'entreprise et décideurs de votre territoire. Échangez en toute confidentialité sur vos enjeux stratégiques, créez des partenariats d\'envergure et bénéficiez de l\'expérience collective pour prendre les meilleures décisions.',
      benefits: [
        'Cercle confidentiel de dirigeants',
        'Événements exclusifs',
        'Partage d\'expériences stratégiques',
        'Opportunités de partenariats',
      ],
      image: 'https://readdy.ai/api/search-image?query=Exclusive%20business%20leaders%20networking%20event%20in%20upscale%20venue%2C%20CEOs%20and%20company%20directors%20engaging%20in%20strategic%20discussions%2C%20premium%20executive%20networking%20atmosphere%20with%20elegant%20setting%2C%20sophisticated%20business%20gathering%2C%20high%20quality%20executive%20event%20photography&width=800&height=600&seq=dirigeant-reseau-001&orientation=landscape',
    },
    {
      number: '03',
      title: 'Optimisation Fiscale & Financière',
      description: 'Maximisez la rentabilité de votre entreprise avec des experts en optimisation fiscale et financière. Structuration juridique, ingénierie patrimoniale, levée de fonds, transmission : des solutions sur mesure pour sécuriser et développer votre patrimoine professionnel.',
      benefits: [
        'Optimisation fiscale légale',
        'Ingénierie patrimoniale',
        'Structuration juridique',
        'Accompagnement levée de fonds',
      ],
      image: 'https://readdy.ai/api/search-image?query=Financial%20advisor%20consulting%20with%20business%20owner%20CEO%20reviewing%20investment%20portfolio%20and%20tax%20optimization%20strategies%20in%20premium%20office%2C%20professional%20wealth%20management%20meeting%20with%20charts%20and%20financial%20documents%2C%20luxury%20corporate%20environment%2C%20high%20quality%20financial%20consulting%20photography&width=800&height=600&seq=dirigeant-fiscal-001&orientation=landscape',
    },
    {
      number: '04',
      title: 'Gouvernance & Innovation',
      description: 'Structurez votre gouvernance et préparez l\'avenir de votre entreprise. Mise en place de comités stratégiques, digitalisation, RSE, innovation managériale : adoptez les meilleures pratiques pour pérenniser votre organisation et attirer les meilleurs talents.',
      benefits: [
        'Structuration de la gouvernance',
        'Stratégie d\'innovation',
        'Transformation digitale',
        'Démarche RSE',
      ],
      image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20boardroom%20meeting%20with%20diverse%20executive%20team%20discussing%20innovation%20strategy%2C%20CEO%20leading%20governance%20session%20with%20digital%20presentation%20and%20strategic%20planning%20materials%2C%20contemporary%20premium%20office%20environment%2C%20high%20quality%20corporate%20governance%20photography&width=800&height=600&seq=dirigeant-gouvernance-001&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-light/5">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="text-center mb-12 md:mb-20">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary-dark mb-3 md:mb-4">
            Nos Solutions pour les Dirigeants
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-dark max-w-2xl mx-auto">
            Un accompagnement d'excellence pour piloter votre croissance
          </p>
        </div>

        <div className="space-y-16 md:space-y-24">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-center ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                <div className="relative">
                  <div className="absolute -top-6 -left-6 md:-top-8 md:-left-8 text-6xl md:text-8xl font-bold text-primary-light/20 select-none">
                    {solution.number}
                  </div>
                  <div className="relative space-y-4 md:space-y-6">
                    <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-primary-dark">
                      {solution.title}
                    </h3>
                    <p className="text-sm md:text-base lg:text-lg text-gray-dark leading-relaxed">
                      {solution.description}
                    </p>
                    <ul className="space-y-2 md:space-y-3">
                      {solution.benefits.map((benefit, idx) => (
                        <li key={idx} className="flex items-start gap-3">
                          <div className="w-5 h-5 md:w-6 md:h-6 flex items-center justify-center bg-primary rounded-full flex-shrink-0 mt-0.5">
                            <i className="ri-check-line text-white text-xs"></i>
                          </div>
                          <span className="text-sm md:text-base text-gray-dark">{benefit}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                <div className="rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
